module.exports = __webpack_public_path__ + "imgs/pos_stock.e723e10f8dd95cb642866a20ff6d2f6b.jpeg";